<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="titlePage" id="tit01">
<a id="page03"></a>
<h2 class="titlePageTitle"><span class="bold">The Nanny</span></h2>
<h2 class="titlePageAuthor"><span class="bold">MELISSA NATHAN</span></h2>
<p class="colophon"><img alt="logo" src="logo.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thenanny.vue?1ae41246